module.exports = __webpack_public_path__ + "img/rec-serial-1.865ab93.png";